// @core/api/endpoints/userprofile/create_default_profile_on_user_created.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateUserprofileRequest,
  UserprofileResponse,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Create a user default profile
 * Creates a default profile for a new user, typically triggered automatically when a user registers. Populates basic profile information from user data.
 */
export async function CreateDefaultProfileOnUserCreated(
  data: CreateUserprofileRequest,
  options?: RequestOptions
): Promise<UserprofileResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/default`;
  const requestOptions = options;
  return client.post<UserprofileResponse>(requestPath, data, requestOptions);
}
